
import momentTimezone from 'moment-timezone';
import moment from 'moment/moment';

export const formatDate = (date, format = 'YYYY-MM-DD') => (date ? momentTimezone.tz(date, 'Africa/Lagos').format(format) : '--');



//truncate text
export const truncateText = (text, maxLength) =>
  text.length > maxLength ? text.substring(0, maxLength) + "..." : text;


// export const formattedDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//     });
//   };

export const formatPatientId = data => {
  if (!data) {
    return '';
  }
  if (data.is_out_patient) {
    return 'UNREG';
  }

  let formattedId = String(data.id);
  let len = 7 - formattedId.length;
  while (len >= 0) {
    formattedId = '0' + formattedId;
    len--;
  }

  const legacyId =
    data.legacy_patient_id && data.legacy_patient_id !== '' ? (+data.legacy_patient_id ? ` [${data.legacy_patient_id}]` : formattedId) : '';

  return legacyId ? legacyId : formattedId;
};


export const checkVaccine = data => {
  if (!data.date_administered) {
    if (moment().isSame(data.date_due, 'day')) {
      return 'yellow';
    } else if (moment().isAfter(data.date_due)) {
      return 'red';
    } else if (moment().isBefore(data.date_due)) {
      return 'grey';
    }
  }
  return 'green';
};

export const groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};





export const formattedDate = (dateString) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("en-GB", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(date);
};


export const formattedDate2 = (dateString) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("en-GB", {
    //   weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(date);
};


export const formattedDate3 = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    weekday: "long",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatCurrency = (amount, currency = "NGN", locale = "en-NG") => {
  if (amount == null || isNaN(amount)) return "-";

  return Math.abs(amount).toLocaleString(locale, {
    style: "currency",
    currency: currency,
  });
}
